import { Button } from '@mui/material'
import { Link16Regular } from '@/components/Icon'

export default function ContextConnectButton({
  children = 'Connect',
  hideIcon = false,
  ...props
}) {
  return (
    <Button
      variant="contextConnect"
      disableElevation
      startIcon={hideIcon ? undefined : <Link16Regular fontSize={18} />}
      sx={hideIcon ? { paddingLeft: '12px' } : undefined}
      {...props}
    >
      {children}
    </Button>
  )
}
